// Lỗi thiếu package: Để sửa lỗi "Module not found: Error: Can't resolve 'lucide-react'",
// bạn cần mở terminal trong thư mục frontend và chạy lệnh: npm install lucide-react
import React, { useState, useEffect, useMemo, useCallback } from 'react';
// Sửa lỗi đường dẫn: Đường dẫn đã được sửa từ '../api' thành '../../api' để trỏ đúng vào thư mục gốc src
// Cập nhật: Thêm apiGetEmployeeInfo để lấy thông tin nhân viên
import { apiGetAllEmpNoTax, apiConfirmEmpNoTax, apiGetBasicCodeOptions, apiGetEmployeeInfo } from '../../api';
import { PlusCircle, Loader2 } from 'lucide-react'; // Thêm icon Loader2

const FamilyRelief = () => {
    const [empNoTaxData, setEmpNoTaxData] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [whsno, setWhsno] = useState('VNA'); // Giá trị mặc định
    
    // Tự động xác định mức giảm trừ mặc định dựa trên năm hiện tại
    const currentYear = new Date().getFullYear();
    const isNewReliefPeriod = currentYear >= 2026;
    const standardRelief = isNewReliefPeriod ? 6200000 : 4400000;
    
    const [defaultUtMtax, setDefaultUtMtax] = useState(standardRelief);
    const [whsnoOptions, setWhsnoOptions] = useState([]);
    const [isSearching, setIsSearching] = useState(false); // State mới để theo dõi việc tìm kiếm MSNV

    const fetchInitialData = useCallback(async () => {
        setIsLoading(true);
        setError('');
        try {
            // Tải song song danh sách giảm trừ và danh sách xưởng
            const [data, whsnoData] = await Promise.all([
                apiGetAllEmpNoTax(),
                apiGetBasicCodeOptions('WHSNO')
            ]);

            const processedData = data.map(item => {
                let processedItem = { ...item, op: '', isNew: false };
                
                // --- LOGIC TỰ ĐỘNG CẬP NHẬT 2026 ---
                // Nếu đã sang năm 2026 mà dữ liệu vẫn là mức cũ (4.4tr), tự động cập nhật lên 6.2tr
                if (isNewReliefPeriod && Number(item.ut_mtax) === 4400000) {
                    processedItem.ut_mtax = 6200000;
                    processedItem.tot_Mtax = (parseFloat(processedItem.person_qty) || 0) * 6200000;
                    processedItem.op = 'E'; // Đánh dấu là đã chỉnh sửa để hiển thị màu vàng
                }
                
                return processedItem;
            });

            setEmpNoTaxData(processedData);
            setOriginalData(JSON.parse(JSON.stringify(processedData))); // Deep copy
            setWhsnoOptions(whsnoData);

        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    }, [isNewReliefPeriod]);

    useEffect(() => {
        fetchInitialData();
    }, [fetchInitialData]);

    // Xử lý khi giá trị input thay đổi
    const handleInputChange = (aid, field, value) => {
        setEmpNoTaxData(prevData => {
            return prevData.map(item => {
                if (item.aid === aid) {
                    const updatedItem = { ...item, [field]: value, op: item.isNew ? 'N' : 'E' };
                    // Tự động tính lại tổng giảm trừ
                    if (field === 'person_qty' || field === 'ut_mtax') {
                        const personQty = parseFloat(updatedItem.person_qty) || 0;
                        const utMtax = parseFloat(updatedItem.ut_mtax) || 0;
                        updatedItem.tot_Mtax = personQty * utMtax;
                    }
                    return updatedItem;
                }
                return item;
            });
        });
    };
    
    // === Cải tiến: Lấy thông tin nhân viên và xử lý trạng thái "treo" ===
    const handleEmpIdBlur = async (aid, empid) => {
        if (!empid) return; // Không làm gì nếu MSNV rỗng

        // Kiểm tra mã nhân viên trùng lặp trước khi gọi API
        const isDuplicate = empNoTaxData.some(item => item.aid !== aid && item.empid === empid);
        if (isDuplicate) {
            alert(`Mã nhân viên ${empid} đã tồn tại trong danh sách.`);
            setEmpNoTaxData(prevData =>
                prevData.map(item => (item.aid === aid ? { ...item, empid: '', empname: '' } : item))
            );
            return;
        }

        setIsSearching(true); // Bắt đầu tìm kiếm, kích hoạt trạng thái loading
        try {
            // Gọi API để lấy thông tin nhân viên
            const empInfo = await apiGetEmployeeInfo(empid);

            // THÊM LOG: In ra dữ liệu nhận được từ API để kiểm tra
            console.log('Dữ liệu nhân viên nhận được từ API:', empInfo);

            if (empInfo) {
                setEmpNoTaxData(prevData =>
                    prevData.map(item => {
                        if (item.aid === aid) {
                            // SỬA LỖI: API trả về trường EMPNAM_VN (viết hoa). Cần truy cập đúng tên trường.
                            return { ...item, empname: empInfo.EMPNAM_VN };
                        }
                        return item;
                    })
                );
            }
        } catch (error) {
            alert(`Không tìm thấy nhân viên với mã số: ${empid}. Vui lòng kiểm tra lại.`);
            // Xóa MSNV và tên không hợp lệ
            setEmpNoTaxData(prevData =>
                prevData.map(item => (item.aid === aid ? { ...item, empid: '', empname: '' } : item))
            );
        } finally {
            setIsSearching(false); // Kết thúc tìm kiếm, tắt trạng thái loading
        }
    };


    // Xử lý khi checkbox "Xóa" được check
    const handleMarkForDeletion = (aid, isNew) => {
        if (isNew) {
            // Nếu là dòng mới, chỉ cần loại bỏ khỏi state
            setEmpNoTaxData(prev => prev.filter(item => item.aid !== aid));
            return;
        }
        setEmpNoTaxData(prevData => {
            return prevData.map(item => {
                if (item.aid === aid) {
                    // Chuyển đổi trạng thái xóa
                    const isMarked = item.op === 'D';
                    // Nếu đang chờ xóa thì quay lại trạng thái sửa, ngược lại thì đánh dấu chờ xóa
                    return { ...item, op: isMarked ? 'E' : 'D' };
                }
                return item;
            });
        });
    };

    const handleAddNewRow = () => {
        const newId = `new_${Date.now()}`;
        const newRow = {
            aid: newId,
            empid: '',
            empname: '', // Thêm trường tên
            person_qty: 1,
            ut_mtax: defaultUtMtax,
            tot_Mtax: defaultUtMtax,
            op: 'N', // 'N' for New
            isNew: true
        };
        setEmpNoTaxData(prev => [newRow, ...prev]);
    };

    // Xử lý khi nhấn nút "Xác nhận"
    const handleConfirm = async () => {
        const recordsToProcess = empNoTaxData.filter(item => ['E', 'D', 'N'].includes(item.op));

        if (recordsToProcess.length === 0) {
            alert('Không có thay đổi nào để xác nhận.');
            return;
        }
         // Kiểm tra các dòng mới có nhập empid không
        const invalidNewRows = recordsToProcess.filter(r => r.isNew && !r.empid);
        if (invalidNewRows.length > 0) {
            alert('Vui lòng nhập Mã số nhân viên cho tất cả các dòng mới.');
            return;
        }


        if (window.confirm(`Bạn có chắc chắn muốn xử lý ${recordsToProcess.length} bản ghi không?`)) {
            setIsLoading(true);
            try {
                const payload = {
                    records: recordsToProcess,
                    whsno: whsno
                };
                const result = await apiConfirmEmpNoTax(payload);
                alert(result.message);
                fetchInitialData();
            } catch (err) {
                alert(`Lỗi khi xác nhận: ${err.message}`);
            } finally {
                setIsLoading(false);
            }
        }
    };

    // Hủy bỏ thay đổi
    const handleCancel = () => {
        if (window.confirm('Bạn có chắc chắn muốn hủy bỏ mọi thay đổi không?')) {
            setEmpNoTaxData(JSON.parse(JSON.stringify(originalData))); // Quay lại dữ liệu gốc
        }
    };


    const filteredData = useMemo(() => {
        if (!searchTerm) return empNoTaxData;
        return empNoTaxData.filter(item =>
            (item.empid && item.empid.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (item.empname && item.empname.toLowerCase().includes(searchTerm.toLowerCase()))
        );
    }, [empNoTaxData, searchTerm]);

    return (
        <div className="p-4 bg-white rounded-lg shadow-md">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Xác nhận Giảm Trừ Gia Cảnh</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4 p-4 border rounded-md">
                 <div>
                    <label className="block text-sm font-medium text-gray-700">Xưởng (廠別)</label>
                    <select
                        value={whsno}
                        onChange={e => setWhsno(e.target.value)}
                        className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                    >
                        {whsnoOptions.map(option => (
                            <option key={option.SYS_TYPE} value={option.SYS_TYPE}>
                                {option.SYS_VALUE}
                            </option>
                        ))}
                    </select>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Mức giảm trừ/người mặc định</label>
                     <input
                        type="number"
                        value={defaultUtMtax}
                        onChange={e => setDefaultUtMtax(Number(e.target.value))}
                        className="mt-1 block w-full px-3 py-2 border rounded-md"
                    />
                </div>
                 <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700">Tìm kiếm theo MSNV hoặc Tên</label>
                    <input
                        type="text"
                        placeholder="..."
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        className="mt-1 block w-full px-3 py-2 border rounded-md"
                    />
                </div>
            </div>

            <div className="flex justify-between items-center mb-4">
                 <button onClick={handleAddNewRow} className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
                    <PlusCircle className="mr-2 h-5 w-5" /> Thêm dòng mới
                </button>
                <div className="flex items-center space-x-2">
                    {/* Hiển thị vòng xoay khi đang tìm kiếm */}
                    {isSearching && <Loader2 className="animate-spin h-5 w-5 text-gray-500" />}
                    <button
                        onClick={handleCancel}
                        className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
                        disabled={isLoading || isSearching} // Vô hiệu hóa nút khi đang tìm kiếm
                    >
                        (N) Hủy bỏ
                    </button>
                    <button
                        onClick={handleConfirm}
                        className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                        disabled={isLoading || isSearching} // Vô hiệu hóa nút khi đang tìm kiếm
                    >
                        (Y) Xác nhận
                    </button>
                </div>
            </div>

            {isLoading && <p>Đang xử lý...</p>}
            {error && <p className="text-red-500">{error}</p>}
            {!isLoading && !error && (
                <div className="overflow-x-auto">
                    <table className="min-w-full bg-white border">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="px-4 py-2 text-center">Xóa</th>
                                <th className="px-4 py-2 text-left">MSNV</th>
                                <th className="px-4 py-2 text-left">Họ Tên</th>
                                <th className="px-4 py-2 text-left">Số người</th>
                                <th className="px-4 py-2 text-left">Mức giảm/người</th>
                                <th className="px-4 py-2 text-left">Tổng giảm trừ</th>
                                <th className="px-4 py-2 text-left">Trạng thái</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y">
                            {filteredData.map(item => {
                                const isMarkedForDeletion = item.op === 'D';
                                const isModified = item.op === 'E' || item.op === 'N';
                                let rowClass = '';
                                if (isMarkedForDeletion) rowClass = 'bg-red-100 line-through';
                                else if (isModified) rowClass = 'bg-yellow-100';

                                return (
                                    <tr key={item.aid} className={rowClass}>
                                        <td className="px-4 py-2 text-center">
                                            <input
                                                type="checkbox"
                                                checked={isMarkedForDeletion}
                                                onChange={() => handleMarkForDeletion(item.aid, item.isNew)}
                                                className="h-5 w-5 text-red-600 border-gray-300 rounded focus:ring-red-500"
                                            />
                                        </td>
                                        <td className="px-4 py-2">
                                             <input
                                                type="text"
                                                value={item.empid}
                                                onChange={e => handleInputChange(item.aid, 'empid', e.target.value.toUpperCase())}
                                                // Thêm sự kiện onBlur để gọi API khi người dùng nhập xong
                                                onBlur={e => item.isNew && handleEmpIdBlur(item.aid, e.target.value)}
                                                disabled={!item.isNew}
                                                className={`w-28 p-1 border rounded-md ${!item.isNew ? 'bg-gray-200 cursor-not-allowed' : 'bg-white'}`}
                                            />
                                        </td>
                                        <td className="px-4 py-2">{item.empname}</td>
                                        <td className="px-4 py-2">
                                            <input
                                                type="number"
                                                value={item.person_qty}
                                                onChange={e => handleInputChange(item.aid, 'person_qty', e.target.value)}
                                                disabled={isMarkedForDeletion}
                                                className="w-24 p-1 border rounded-md"
                                            />
                                        </td>
                                        <td className="px-4 py-2">
                                            <input
                                                type="number"
                                                step="1000"
                                                value={item.ut_mtax}
                                                onChange={e => handleInputChange(item.aid, 'ut_mtax', e.target.value)}
                                                disabled={isMarkedForDeletion}
                                                className="w-36 p-1 border rounded-md"
                                            />
                                        </td>
                                        <td className="px-4 py-2">
                                            <input
                                                type="text"
                                                value={Number(item.tot_Mtax || 0).toLocaleString('vi-VN')}
                                                readOnly
                                                className="w-36 p-1 border rounded-md bg-gray-100"
                                            />
                                        </td>
                                        <td className="px-4 py-2">
                                            {item.op === 'E' && <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-200 text-yellow-800">Đã sửa</span>}
                                            {item.op === 'D' && <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-200 text-red-800">Chờ xóa</span>}
                                            {item.op === 'N' && <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-200 text-green-800">Mới</span>}
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default FamilyRelief;